import { datadogRum } from '@datadog/browser-rum';
import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import environment from './environment';
import Fallback from './layout/FallBack';

const {
  ADMINIFI_URL,
  CERTIFICATE_SERVICE_URL,
  CONTENT_SERVICE_URL,
  COMPLIANCE_URL,
  DASHIFI_URL,
  DATADOG_APPLICATION_ID,
  DATADOG_CLIENT_TOKEN,
  EVALUFI_URL,
  NOTIFI_URL,
  STAGE,
  VERSION,
  DISABLE_TELEMETRY,
} = environment;

const qualifiMocksEnabled =
  import.meta.env.VITE_ENABLE_QUALIFI_MOCKS === 'true' &&
  (import.meta.env.VITE_STAGE === 'dev' || import.meta.env.VITE_STAGE === 'development');

if (!DISABLE_TELEMETRY && !window.Cypress) {
  if (DATADOG_APPLICATION_ID) {
    datadogRum.init({
      allowedTracingUrls: [
        ADMINIFI_URL,
        CERTIFICATE_SERVICE_URL,
        CONTENT_SERVICE_URL,
        COMPLIANCE_URL,
        DASHIFI_URL,
        EVALUFI_URL,
        NOTIFI_URL,
      ],
      applicationId: DATADOG_APPLICATION_ID,
      clientToken: DATADOG_CLIENT_TOKEN,
      env: STAGE,
      sessionSampleRate: 50,
      service: 'dashifi',
      sessionReplaySampleRate: 0,
      site: 'datadoghq.com',
      trackResources: true,
      trackLongTasks: true,
      trackUserInteractions: true,
      trackSessionAcrossSubdomains: true,
      propagateTraceBaggage: false,
      version: VERSION,
    });
  }
}

const root = createRoot(document.getElementById('root'));

const renderApplication = () => {
  root.render(
    <React.StrictMode>
      <Suspense fallback={<Fallback />}>
        <App />
      </Suspense>
      {STAGE !== 'production' && <div style={{ display: 'none' }}>{`version: ${VERSION}`}</div>}
    </React.StrictMode>
  );
};

const startApplication = async () => {
  // Cypress owns its responses with cy.intercept so each scenario is explicit
  // and deterministic. Normal local/dev sessions use contract-backed MSW.
  if (qualifiMocksEnabled && !window.Cypress) {
    try {
      const { startQualifiMocks } = await import('./common/qualifi/mocks/start');
      await startQualifiMocks();
    } catch (error) {
      console.warn('Dashifi could not start the QualiFi mock service. Continuing with the real API.', error);
    }
  }

  renderApplication();
};

void startApplication();
